import { render, staticRenderFns } from "./mdMajorTable.vue?vue&type=template&id=5f999866&scoped=true&"
import script from "./mdMajorTable.vue?vue&type=script&lang=js&"
export * from "./mdMajorTable.vue?vue&type=script&lang=js&"
import style0 from "./mdMajorTable.vue?vue&type=style&index=0&id=5f999866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f999866",
  null
  
)

export default component.exports